"use client";

import { LazyLoadImage } from "react-lazy-load-image-component";

export default function LazyImage({ itemRef, className, src, width, height, onClick }) {
  return <LazyLoadImage itemRef={itemRef} className={className} width={width ?? 50} height={height ?? 50} src={src} onClick={onClick} />;
}